import { baseURL } from "../../util/Constant";
import { setHtmlContentSH, setLoadingSH, setErrorSH } from '../redux/storageFileSlice';

export const fetchOrderFileSH = (numOrder) => async (dispatch) => {
  dispatch(setLoadingSH());
  try {
    const response = await fetch(`${baseURL}/email/search/sh/${numOrder}`);
    const data = await response.json();
    // console.log('Получен файл:', data);
      dispatch(setHtmlContentSH(data));
   
  } catch (error) {
    dispatch(setErrorSH(error.message));
  }
};